<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  completed: { type: Number, default: 0 },
  total: { type: Number, default: 0 },
});

const { t } = useI18n();

const percentage = computed(() => {
  if (props.total === 0) return 0;
  return Math.min(Math.round((props.completed / props.total) * 100), 100);
});

const barColor = computed(() => {
  if (percentage.value === 100) return 'bg-n-teal-9';
  return 'bg-n-brand';
});
</script>

<template>
  <div class="flex items-center min-w-0 group">
    <span
      class="hidden md:inline text-xs text-n-slate-11 whitespace-nowrap flex-shrink-0 overflow-hidden max-w-0 opacity-0 group-hover:max-w-[10rem] group-hover:opacity-100 group-hover:mr-2 transition-all duration-300 ease-out"
    >
      {{ t('TASKS.PROGRESS.PENDING', { count: total - completed }) }}
    </span>
    <div
      class="w-16 md:w-64 h-1.5 bg-n-weak rounded-full overflow-hidden flex-shrink-0"
    >
      <div
        class="h-full rounded-full transition-all duration-500"
        :class="barColor"
        :style="{ width: percentage + '%' }"
      />
    </div>
    <span
      class="hidden md:inline text-xs text-n-slate-11 whitespace-nowrap flex-shrink-0 overflow-hidden max-w-0 opacity-0 group-hover:max-w-[10rem] group-hover:opacity-100 group-hover:ml-2 transition-all duration-300 ease-out"
    >
      {{ t('TASKS.PROGRESS.COMPLETED', { count: completed }) }}
    </span>
  </div>
</template>
